import React from 'react';

import TextSpellcheckIcon from '@atlaskit/icon/core/text-spellcheck';

export const FixSpellingIcon = () => (
	<TextSpellcheckIcon label="" color="currentColor" spacing="spacious" />
);
